export default "__VITE_ASSET__1bca039f__"